// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"524":"9b8cfd2d","537":"90fb1c55"}[chunkId] + ".chunk.js";
};